module.exports = "<svg id=786b775d-4fe6-484c-b8bc-0c98177d005a data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Warning</title><path d=M11.25,10v4.37a.75.75,0,1,0,1.5,0V10a.75.75,0,0,0-1.5,0Z /><circle cx=12 cy=16.9 r=0.75 /><path d=M12.5,4.74a.53.53,0,0,0-1,0L3.12,19.25c-.28.48-.05.88.5.88H20.38c.55,0,.78-.4.5-.88ZM4.36,19.12,12,5.88l7.64,13.24Z /></svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/extensions/grid/images/warning.svg
// module id = 173
// module chunks = 0